interface SDKManifest {
  version: string;
  lastUpdated: string;
  sdks: Record<string, any>;
  recommended: string;
  fallback: string;
}

interface SDKVersionInfo {
  version: string;
  fallback: string;
  isCached: boolean;
}

class SDKService {
  private cachedManifest: SDKManifest | null = null;
  private cacheTimestamp: number = 0;
  private readonly CACHE_TTL = 5 * 60 * 1000; // 5 minutes

  async getRecommendedSDK(): Promise<SDKVersionInfo> {
    // Check cache first
    if (this.cachedManifest && Date.now() - this.cacheTimestamp < this.CACHE_TTL) {
      return this.extractVersions(this.cachedManifest);
    }

    try {
      const SERVER_URL = import.meta.env.VITE_API_BASE_URL;
      const response = await fetch(`${SERVER_URL}/sdk-manifest.json`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch SDK manifest: ${response.status}`);
      }
      
      this.cachedManifest = await response.json();
      this.cacheTimestamp = Date.now();
      
      return this.extractVersions(this.cachedManifest);
    } catch (error) {
      console.error('Failed to fetch SDK manifest, using fallback:', error);
      // Fallback to hardcoded version if fetch fails
      return {
        version: '2.1.4',
        fallback: '2.1.3',
        isCached: false
      };
    }
  }

  private extractVersions(manifest: SDKManifest): SDKVersionInfo {
    return {
      version: manifest.recommended.replace('beemi-sdk-', ''),
      fallback: manifest.fallback.replace('beemi-sdk-', ''),
      isCached: true
    };
  }

  clearCache() {
    this.cachedManifest = null;
    this.cacheTimestamp = 0;
  }
}

export const sdkService = new SDKService();
